/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Account from './Account/index'
import Auth from './Auth/index'
import ChooseLocation from './ChooseLocation/index'
import No from './No/index'
import NotFound from './NotFound/index'
import Notifications from 'DesignSystem/Notifications/index'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let CaptureImageSeries = React.lazy(() => import('./CaptureImageSeries/index'))
let DesignSystem = React.lazy(() => import('./DesignSystem/index'))
let FakeCore = React.lazy(() => import('./FakeCore/index'))
let PreviewContract = React.lazy(() => import('./PreviewContract/index'))



/** @type {import('Simple/types.js').View} */
export default function App({
  children,
  viewPath = "/App"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
 onClickSignOut={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Auth/SignOut'))}
 isSelectedSignOut={flow.has(fromFlow.normalizePath(viewPath, 'Auth/SignOut'))}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'No'}>
<No
{...childProps}
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Auth'}>
<Auth
{...childProps}
  viewPath={`${viewPath}/Auth`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Account'}>
<Account
{...childProps}
  viewPath={`${viewPath}/Account`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ChooseLocation'}>
<ChooseLocation
{...childProps}
  viewPath={`${viewPath}/ChooseLocation`}
/>
</fromFlow.When>
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<fromFlow.When is={flowValue === 'CaptureImageSeries'}>
<CaptureImageSeries
{...childProps}
  viewPath={`${viewPath}/CaptureImageSeries`}
/>
</fromFlow.When>
)}
</SuspenseBoundary>
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<fromFlow.When is={flowValue === 'PreviewContract'}>
<PreviewContract
{...childProps}
  viewPath={`${viewPath}/PreviewContract`}
/>
</fromFlow.When>
)}
</SuspenseBoundary>
<fromFlow.When is={flowValue === 'FakeCore'}>
<FakeCore
{...childProps}
  viewPath={`${viewPath}/FakeCore`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotFound'}>
<NotFound
{...childProps}
  viewPath={`${viewPath}/NotFound`}
/>
</fromFlow.When>
<div
  data-testid="App.Vertical"
  data-view-path={viewPath}
 style={{'--t-1-hJL': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--r-2-hJL': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<Notifications
  viewPath={`${viewPath}/Notifications`}
/>
</div>
<fromFlow.When is={flowValue === 'DesignSystem'}>
<DesignSystem
{...childProps}
  viewPath={`${viewPath}/DesignSystem`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SentryErrorBoundary>
{children}
</React.Fragment>)
}